import Screen from '@/styles/Themes/Screen';
import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from 'src/styles/Themes/Text';

export const ListWrapper = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin-bottom: 20px;

    ${Screen.ipad} {
        grid-gap: 30px;
        margin-bottom: 30px;
    }
    ${Screen.desktop} {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr;
        margin: 10px 0 30px;
    }
`;

export const LoadMoreTrigger = styled.div`
    position: absolute;
    display: block;
    width: 1px;
    height: 1px;
    bottom: 300px;
    left: -5px;
`;

export const DimmerContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 10px 0;
`;

export const ListTitle = styled.h1`
    ${Text.Full.heading2};
    margin: 25px 0;
    color: ${cssVars.fg_gray1_white};

    ${Screen.desktop} {
        margin: 35px 0;
    }
`;

export const FeatureWrapper = styled.div`
    margin: 25px 0 0;
`;
